import { ReactNode, useRef } from "react";

/**
 * Modale di conferma riusabile.
 *
 * Pattern controllato dal parent: il parent gestisce isOpen tramite stato locale
 * e passa onConfirm/onCancel. Click sul backdrop = cancel. Stop propagation sul
 * card per evitare chiusura accidentale durante interazioni con il contenuto.
 */
export function ConfirmModal({
  title,
  message,
  confirmLabel,
  cancelLabel = "Annulla",
  danger,
  onConfirm,
  onCancel,
  loading,
}: {
  title: string;
  message: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}) {
  const backdropMouseDown = useRef(false);
  return (
    <div
      className="dialog-overlay"
      onMouseDown={(e) => { backdropMouseDown.current = e.target === e.currentTarget; }}
      onClick={(e) => { if (!loading && e.target === e.currentTarget && backdropMouseDown.current) onCancel(); }}
    >
      <div className="dialog-card" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>{title}</h2>
        </div>
        <div className="text-sm text-muted" style={{ marginBottom: "var(--space-5)", lineHeight: 1.5 }}>
          {message}
        </div>
        <div className="dialog-footer">
          <button className="btn btn-ghost" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            className={`btn ${danger ? "btn-danger" : "btn-primary"}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Attendere…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
